import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip } from 'recharts';
import type { AnalyticsSuccessRate } from '../../services/api';

interface OverviewTabProps {
  data?: AnalyticsSuccessRate[];
}

const OverviewTab: React.FC<OverviewTabProps> = ({ data }) => {
  const chartData = data && data.length > 0
    ? data.map(item => ({
      label: item.label,
      value: item.value
    }))
    : [];

  if (chartData.length === 0) {
    return (
      <div className="tab-content">
        <div className="no-data-message">
          <p>No transactions data available for the selected period.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="tab-content">
      <div className="chart-container">
        <h3 className="chart-title">Transaction Success Rate (%)</h3>
        <div className="chart-wrapper">
          <ResponsiveContainer width="100%" height={400}>
            <AreaChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <defs>
                <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#10b981" stopOpacity={0.1} />
                  <stop offset="95%" stopColor="#10b981" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
              <XAxis
                dataKey="label"
                tick={{ fontSize: 12, fill: '#64748b' }}
                axisLine={false}
                tickLine={false}
              />
              <YAxis
                tick={{ fontSize: 12, fill: '#64748b' }}
                axisLine={false}
                tickLine={false}
                domain={[0, 100]}
              />
              <Tooltip
                contentStyle={{ borderRadius: '10px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
              />
              <Area
                type="monotone"
                dataKey="value"
                stroke="#10b981"
                strokeWidth={3}
                fillOpacity={1}
                fill="url(#colorValue)"
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
